window.tinyMCE.PluginManager.add('customcolumns', function (editor) {
  const columnIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    // First row of three lines
    '<rect x="2" y="4" width="4" height="1" />' +
    '<rect x="8" y="4" width="4" height="1" />' +
    '<rect x="14" y="4" width="4" height="1" />' +
    // Second row of three lines
    '<rect x="2" y="8" width="4" height="1" />' +
    '<rect x="8" y="8" width="4" height="1" />' +
    '<rect x="14" y="8" width="4" height="1" />' +
    // Third row of three lines
    '<rect x="2" y="12" width="4" height="1" />' +
    '<rect x="8" y="12" width="4" height="1" />' +
    '<rect x="14" y="12" width="4" height="1" />' +
    '<rect x="2" y="16" width="4" height="1" />' +
    '<rect x="8" y="16" width="4" height="1" />' +
    '<rect x="14" y="16" width="4" height="1" />' +
    '</svg>';
  editor.ui.registry.addIcon('customColumns', columnIcon);

  // Function to insert columns and rows without borders
  function insertColumnsAndRows(columns, rows) {
    let tableHtml = '<table style="width: 100%; border-collapse: collapse; border: none;">';
    for (let i = 0; i < rows; i++) {
      tableHtml += '<tr>';
      for (let j = 0; j < columns; j++) {
        tableHtml += `<td style="border: none; padding: 8px;">Column ${String.fromCharCode(
          65 + j
        )} - Row ${i + 1}</td>`;
      }
      tableHtml += '</tr>';
    }
    tableHtml += '</table>';
    tableHtml += '<p style="page-break-after: always;"></p>'; // Insert page break
    editor.insertContent(tableHtml);
  }

  // Command to open the dialog
  editor.addCommand('mceInsertCustomColumns', function () {
    editor.windowManager.open({
      title: 'Insert Columns and Rows',
      body: {
        type: 'panel',
        items: [
          {
            type: 'input',
            name: 'columns',
            label: 'Number of Columns',
            inputMode: 'numeric'
          },
          {
            type: 'input',
            name: 'rows',
            label: 'Number of Rows',
            inputMode: 'numeric'
          }
        ]
      },
      buttons: [
        {
          text: 'Insert',
          type: 'submit',
          primary: true
        },
        {
          text: 'Cancel',
          type: 'cancel'
        }
      ],
      onSubmit: function (api) {
        const data = api.getData();
        const columns = parseInt(data.columns, 10);
        const rows = parseInt(data.rows, 10);
        if (isNaN(columns) || isNaN(rows) || columns <= 0 || rows <= 0) {
          editor.windowManager.alert('Please enter valid positive numbers for columns and rows.');
        } else {
          insertColumnsAndRows(columns, rows);
        }
        api.close();
      }
    });
  });

  // Add button to the toolbar
  editor.ui.registry.addButton('customcolumns', {
    icon: 'customColumns', // Use the customColumns icon
    tooltip: 'Insert Columns and Rows',
    onAction: function () {
      editor.execCommand('mceInsertCustomColumns');
    }
  });

  return {
    getMetadata: function () {
      return {
        name: 'Custom Columns Plugin',
        url: 'https://example.com'
      };
    }
  };
});

// Initialize TinyMCE
window.tinyMCE.init({
  selector: 'textarea',
  height: 500,
  menubar: true,
  plugins: 'customcolumns',
  toolbar: 'undo redo | customcolumns',
  setup: function (editor) {
    editor.on('init', function () {
      const statusbar = editor.theme.panel && editor.theme.panel.find('statusbar')[0];
      if (statusbar) {
        statusbar.insert(
          {
            type: 'label',
            name: 'margin-status',
            text: 'Left Margin: 0%, Right Margin: 0%',
            classes: 'margin-status-bar'
          },
          0
        );
      }
    });
  },
  content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
});
